import axios from 'axios'
import { attachSessionExpiryInterceptors } from '../services/session_expiry'

const instance = axios.create({
    baseURL: process.env.REACT_APP_SOCIAL_ENDPOINT,
    timeout: 30000,
})

attachSessionExpiryInterceptors(instance, 'social_token')

export default instance
